module.exports = __webpack_public_path__ + "static/media/loading_mg.a11818b9.gif";